<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><a id="page3"></a>Hang On</p>
<p class="noindent">Domestic as</p>
<p class="noindents">an empty shopping cart</p>
<p class="noindents">parked on a ledge</p>
<p class="noindents">above a freeway.</p>
<p class="center"><img alt="image" src="images/logo.jpg"/></p>
<p class="noindent">Artifactual as</p>
<p class="noindents">an acorn barnacle.</p>
<p class="noindent">“What is the purpose of barnacles?”</p>
<p class="noindents">people ask the internet.</p>
<p class="noindent">Barnacles are filter feeders.</p>
<p class="noindent">They’re fish tank décor.</p>
<p class="noindent">A plaque of barnacles</p>
<p class="noindents">on top of a toilet—</p>
<p class="noindent">this cluster</p>
<p class="noindents">of brittle puckers,</p>
<p class="noindent">clinging</p>
<p class="noindents">to its old idea,</p>
<p class="noindent">these craters striped</p>
<p class="noindents">pale lavender</p>
<p class="noindent">for some</p>
<p class="noindents">unlikely eye.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Chapter001.vue?35081941